module.exports = __webpack_public_path__ + "assets/images/cancel.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/cancel.png
// module id = 1494
// module chunks = 1